import { useState } from 'react';
import { BankStatementsPage } from './BankStatementsPage';
import { PayoutReconciliationTab } from './PayoutReconciliationTab';

/** Reconciliation: one page, a tab per kind of match. #688 Bank statements, #690 POSP payouts. */
type Tab = 'statements' | 'posp_payouts';

const TABS: { key: Tab; label: string }[] = [
  { key: 'statements', label: 'Bank statements' },
  { key: 'posp_payouts', label: 'POSP payouts' },
];

export function ReconciliationPage() {
  const [tab, setTab] = useState<Tab>('statements');
  return (
    <div>
      <div role="tablist" aria-label="Reconciliation" className="mb-4 flex border-b border-gray-200 dark:border-gray-700">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 text-sm font-medium ${
              tab === t.key
                ? 'border-b-2 border-primary-600 text-primary-700 dark:text-primary-400'
                : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'statements' ? <BankStatementsPage /> : <PayoutReconciliationTab />}
    </div>
  );
}
